import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../core/services/api.service';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';
import { TopAreaCardComponent } from './top-area-card/top-area-card';

interface TopAreaItem {
  propertiesCount: number;
  thumbnail: string;
  area: string;
  isFeatured: boolean;
}

interface TopAreasResponse {
  results: number;
  data: TopAreaItem[];
}

@Component({
  selector: 'app-home-top-areas',
  imports: [CommonModule, TopAreaCardComponent, TranslatePipe],
  templateUrl: './home-top-areas.html',
  styleUrl: './home-top-areas.scss',
  standalone: true,
})
export class HomeTopAreas implements OnInit, OnDestroy {
  topAreas: TopAreaItem[] = [];
  isLoading = false;
  errorMessage = '';
  private subscription: Subscription | null = null;

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadTopAreas();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  loadTopAreas(): void {
    this.isLoading = true;
    this.errorMessage = '';

    this.subscription = this.apiService.get<any>('/public/search/units-and-properties?page=1&limit=6').subscribe({
      next: (response) => {
        const units = response?.results?.data || [];
        const areaMap = new Map<string, TopAreaItem>();

        units.forEach((unit: any) => {
          const locationName = unit?.location?.city || unit?.location?.area;
          if (locationName) {
            const trimmedName = locationName.trim();
            if (!areaMap.has(trimmedName)) {
              areaMap.set(trimmedName, {
                area: trimmedName,
                propertiesCount: 1,
                thumbnail: unit?.thumbnail?.secure_url || '',
                isFeatured: unit?.isFeatured || false,
              });
            } else {
              const existing = areaMap.get(trimmedName)!;
              existing.propertiesCount += 1;
            }
          }
        });

        this.topAreas = Array.from(areaMap.values());
        this.isLoading = false;
      },
      error: () => {
        this.errorMessage = 'Failed to load top areas';
        this.topAreas = [];
        this.isLoading = false;
      },
    });
  }
}
